import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles<Theme>((theme) =>
  createStyles({
    dialogPaper: {
      borderRadius: '25px !important',
      padding: '20px',
      maxWidth: '350px',
    },
    title: {
      color: theme.palette.primary.main,
      //   normal normal bold 24px/28px Noto Sans
      fontSize: '24px',
      fontWeight: 'bold',
      fontFamily: 'Noto Sans',
    },
    button: {
      borderRadius: '17px',
      backgroundColor: theme.palette.primary.main,
      color: '#FFF',
      maxHeight: '50px',
      maxWidth: '120px',
      '&:first-child': {
        marginBottom: '8px',
      },
      '&.MuiButton-outlined': {
        backgroundColor: '#FFF',
        color: '#646464',
        border: '1px solid #646464',
        maxWidth: '195px',
      },
    },
  })
);

export default useStyles;
